import {ThemeIconKey} from 'platform/foundation';

export const RECORD_AUDIT_ICON: ThemeIconKey = 'action/assignment_turned_in';
